import Vue from 'vue'
import Vuex, {StoreOptions} from 'vuex'
import { MealState } from './state'
import { mealGetters } from './getters'
import { mealMutations } from './mutations'
import { mealActions } from './actions'

Vue.use(Vuex);

export const meals = {
  namespaced: true,
  state: new MealState(),
  getters: mealGetters,
  mutations: mealMutations,
  actions: mealActions
} as StoreOptions<MealState>;

export * from './types'
export * from './state'
export default meals;
